import(/* webpackMode: "eager" */ "/vercel/path0/app/(with-global-style)/events/error.tsx");
